export default __webpack_public_path__ + "static/media/a024-10.0fa55094.svg";